import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const employmentStatus: AnswerPathTreeNode = {
  path: 'employmentStatus',
  nodeId: NodeIds.insuredEmploymentStatus,
};
